<script>
  import { init, _ } from "svelte-i18n";

  export let product = null;
</script>

<div class="masonry-item">
  <a href={product.permalink}>
    <img
      class="masonry-image"
      src={product?.images?.[0]?.sizes["woocommerce_thumbnail"] ??
        "/wp-content/uploads/woocommerce-placeholder.png"}
      alt={product.name}
    />
  </a>
</div>

<style>
  .masonry-item {
    /*width: 300px;*/
    /* margin-bottom: 20px; */
    list-style: none;
    box-sizing: border-box;
    /* margin-bottom: 10px; */
  }

  .masonry-item a {
    display: block;
    font-size: 0px;
  }

  .masonry-item img {
    height: 200px;
    /* padding-right: 20px;
    padding-bottom: 20px; */
    /* width: auto; */
    /* height: 300px; */
  }

  .woocommerce-loop-product__title a {
    word-break: break-all;
  }

  @media (max-width: 768px) {
  }
</style>
